import { Drawer, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "@/store/slices/ui.slice";
import { selectSidebarOpen } from "@/store/selectors/ui.selectors";
import SidebarContent from "./SidebarContent";

export default function Sidebar(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const sidebarOpen = useSelector(selectSidebarOpen);
  const dispatch = useDispatch();

  if (isMobile) {
    return (
      <Drawer
        open={sidebarOpen}
        onClose={() => dispatch(setSidebarOpen(false))}
        sx={{
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
          },
        }}
      >
        <SidebarContent />
      </Drawer>
    );
  }

  return (
    <Drawer
        variant="persistent"
        open={sidebarOpen}
        sx={{
          width: 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            top: 64, // 设置为 64px，确保 Sidebar 内容与 Header 有足够的边距
            height: `calc(100% - 64px)`, // 调整高度
          },
        }}
      >
      <SidebarContent />
    </Drawer>
  );
}
